import dayjs from 'dayjs';
import type { GetPromotedPartnerGamesResponse, PromotedPartnerGamesTransformed } from 'src/types/partner-games';

export const transformPromotedPartnerGamesResponse = (
  res: GetPromotedPartnerGamesResponse,
): PromotedPartnerGamesTransformed => {
  const now = dayjs();

  return res.map((game) => {
    const status = dayjs(game.startEffectiveDate).isAfter(now) ? 'pending' : 'active';

    return {
      ...game,
      status,
    };
  });
};
